import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorDeCargos',
  setup(__props) {

const cargos = [
  "ARQUITETO",
  "ARQUITETO ADJUNTO",
  "BIBLIOTECARIO",
  "BIBLIOTECARIO ADJUNTO",
  "CHANCELER",
  "COBRIDOR",
  "COBRIDOR EXTERNO",
  "COBRIDOR INTERNO",
  "GUARDA DO TEMPLO",
  "HOSPITALEIRO",
  "MARECHAL",
  "MESTRE DE BANQUETE",
  "MESTRE DE CERIMONIAS",
  "MESTRE DE HARMONIA",
  "ORADOR",
  "PAST MASTER",
  "VENERAVEL MESTRE DE HONRA",
  "PORTA-BANDEIRA",
  "PORTA-ESPADA",
  "PORTA-ESTANDARTE",
  "PRIMEIRO DIACONO",
  "PRIMEIRO EXPERTO",
  "PRIMEIRO VIGILANTE",
  "SECRETARIO",
  "SEGUNDO DIACONO",
  "SEGUNDO EXPERTO",
  "SEGUNDO VIGILANTE",
  "TERCEIRO EXPERTO",
  "TESOUREIRO",
  "VENERAVEL MESTRE",
  'PRIMEIRO MORDOMO',
  'SEGUNDO MORDOMO',
].toSorted((a, b) => a.localeCompare(b));

return { __sfc: true,cargos }
}

})